// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useTranslation } from 'react-i18next';

function NoteSP(props) {
  const { t } = useTranslation();
  return (
    <>
      <div className="my-note-sp mt-80">
        <div className="d-flex align-items-center">
          <div className="btn-event-lottery">{t('lotteryEventTermsToPay')}</div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>画像と実際の商品は異なる場合がございます。</div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>掲載されている内容は予告なく変更する場合がございます。</div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>くじ商品は基本的に同梱となりますが、数が多い場合はその限りではありません。</div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>この商品はご要望が多い場合、再販売する可能性があります。</div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>
            大量生産による若干の個体差（製品イメージを大きく損なわない程度の微細なキズ・縫製・糸くずなど）に関しましては交換対象外となります。
          </div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>開封や一度でも使用したものなどは対象外となります。</div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>
            注文数が多い場合、発送開始から終了まで2週間〜1ヶ月程度、お時間をいただく場合があります。
            <br />
            出荷の順番は購入順ではございませんのでご了承ください。{' '}
          </div>
        </div>
        <div className="ul-note">
          <div className="ul-note-icon">※</div>
          <div>
            ＋On Challengeに当せん個数の記載がない場合は、個数を公表しておりません。
            <br />
            お問合せをいただいても回答できかねますので、ご了承ください。
          </div>
        </div>
      </div>
    </>
  );
}

export default NoteSP;
